const MentorCard = ({ name, title, photo }) => (
  <div
    className="relative w-[280px] sm:w-[357px] h-[160px] sm:h-[200px] rounded-xl overflow-hidden shrink-0 bg-[#1F2358] bg-cover bg-center"
    style={photo ? { backgroundImage: `url(${photo})` } : undefined}
  >
    {name && (
      <div className="absolute left-6 right-[150px] top-[50px] bottom-[50px] sm:left-8 sm:right-[192px] sm:top-[63px] sm:bottom-[63px] flex flex-col justify-center gap-1 text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)]">
        <span className="font-gilroy-bold text-lg sm:text-2xl leading-tight">{name}</span>
        {title && <span className="text-xs sm:text-sm opacity-90 whitespace-pre-line">{title}</span>}
      </div>
    )}
  </div>
);

export default MentorCard;
